import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { Stack, Box, Modal, Slide, Typography, Collapse, Popper, Fade, Card, IconButton, Button } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { logout } from "Redux/authSlice";

import { LOGO } from "Constants";

interface ILink {
  href: string;
  text: string;
  icon: string;
}

const LINKS: ILink[] = [
  { href: "/", text: "صفحه اصلی", icon: "mingcute:home-3-fill" },
  { href: "/services", text: "سرویس های تحت پوشش", icon: "material-symbols:library-add-check" },
  { href: "/download", text: "اپلیکیشن و دی ان اس", icon: "material-symbols:cloud-download-rounded" },
  { href: "/subscription", text: "سرویس ویژه", icon: "ri:vip-crown-2-fill" },
  { href: "/how-to-use", text: "آموزش استفاده از سرویس", icon: "material-symbols:school" },
  { href: "/request", text: "درخواست سرویس جدید", icon: "tabler:info-square-rounded" },
  { href: "/contact-us", text: "تماس با ما", icon: "mdi:support" },
];

export default function Header() {
  const location = useLocation();

  const dispatch = useAppDispatch();
  const { isLoggedIn, username } = useAppSelector((state) => state.auth);

  const navigate = useNavigate();

  const [menu, setMenu] = useState<boolean>(false);
  const [showUserMenu, setShowUserMenu] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const renderLinks = () => {
    return (
      <Stack direction={{ xs: "column", lg: "row" }} alignItems={{ xs: "flex-start", lg: "center" }} spacing={4}>
        {LINKS.map((link, index) => {
          const isActive = location.pathname === link.href;

          return (
            <Link to={link.href}>
              <Stack direction="row" alignItems="center" spacing={1} sx={{ color: "#fff", px: 1, position: "relative" }}>
                <Icon icon={link.icon} fontSize="30px" />
                <Collapse in={isActive} orientation="horizontal" sx={{ display: { xs: "none", lg: "block" } }}>
                  <Typography fontSize="18px" noWrap>
                    {link.text}
                  </Typography>
                </Collapse>

                <Typography fontSize="18px" noWrap sx={{ display: { lg: "none" } }}>
                  {link.text}
                </Typography>

                <Box
                  sx={{
                    position: "absolute",
                    bottom: "-10px",
                    left: "9px",
                    width: "12px",
                    height: "4px",
                    borderRadius: "100px",
                    bgcolor: "#fff",
                    opacity: isActive ? 1 : 0,
                    transition: "all 0.3s",
                  }}
                />
              </Stack>
            </Link>
          );
        })}

        <Box sx={{ display: { xs: "block", lg: "none" } }}>
          {isLoggedIn ? (
            <Stack spacing={4} alignItems="flex-start">
              <Link to="/change-password">
                <Stack direction="row" alignItems="center" spacing={1} sx={{ color: "#fff", px: 1, position: "relative" }}>
                  <Icon icon="carbon:password" fontSize="30px" />

                  <Typography fontSize="18px" noWrap sx={{ display: { lg: "none" } }}>
                    تغییر رمز عبور
                  </Typography>
                </Stack>
              </Link>
              <Button sx={{ p: 0 }} onClick={handleLogout}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ color: "#fff", px: 1, position: "relative" }}>
                  <Icon icon="ic:round-login" fontSize="30px" />

                  <Typography fontSize="18px" noWrap sx={{ display: { lg: "none" } }}>
                    خروج
                  </Typography>
                </Stack>
              </Button>
            </Stack>
          ) : (
            <Link to="/login">
              <Stack direction="row" alignItems="center" spacing={1} sx={{ color: "#fff", px: 1, position: "relative" }}>
                <Icon icon="ic:round-login" fontSize="30px" />

                <Typography fontSize="18px" noWrap sx={{ display: { lg: "none" } }}>
                  ورود
                </Typography>
              </Stack>
            </Link>
          )}
        </Box>
      </Stack>
    );
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (isLoggedIn) {
      setAnchorEl(event.currentTarget);
      setShowUserMenu((prev) => !prev);
    } else {
      navigate("/login");
    }
  };
  const handleLogout = () => {
    dispatch(logout());
    setShowUserMenu(false);
    setMenu(false);
  };
  const toggleMenu = () => setMenu((prev) => !prev);

  useEffect(() => {
    setMenu(false);
    setShowUserMenu(false);
  }, [location.pathname]);

  return (
    <>
      <Popper open={showUserMenu} anchorEl={anchorEl} placement="bottom-start" transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Card sx={{ mt: 1 }}>
              <Stack sx={{ width: "200px" }}>
                <Link to="/change-password">
                  <Button sx={{ color: "text.primary", width: "100%", borderRadius: "0", py: 1.2 }} size="large">
                    تغییر رمز عبور
                  </Button>
                </Link>
                <Button
                  sx={{ color: "text.primary", flexGrow: 1, borderRadius: "0", py: 1.2 }}
                  size="large"
                  onClick={handleLogout}
                >
                  خروج
                </Button>
              </Stack>
            </Card>
          </Fade>
        )}
      </Popper>

      <Box sx={{ px: { xs: 3, lg: 5 }, pt: 3, position: "absolute", top: "0", width: "100%" }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{}}>
          <Stack direction="row" alignItems="center" spacing={10} sx={{ display: { xs: "none", lg: "flex" } }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <IconButton onClick={handleClick}>
                <Icon icon="mdi:user-circle" fontSize="35px" color="#fff" />
              </IconButton>

              {isLoggedIn && <Typography>{username}</Typography>}
            </Stack>

            {renderLinks()}
          </Stack>

          <IconButton onClick={toggleMenu} sx={{ display: { xs: "flex", lg: "none" } }}>
            <Icon icon="material-symbols:menu-rounded" fontSize="35px" color="#fff" />
          </IconButton>

          <img src={LOGO} alt="logo" height="38px" />
        </Stack>
      </Box>

      <Modal open={menu} onClose={toggleMenu} sx={{ zIndex: 2000000003 }}>
        <Slide direction="left" in={menu}>
          <Box
            sx={{
              height: "100vh",
              width: "280px",
              bgcolor: "primary.main",
              boxShadow: 10,
              borderTopRightRadius: "20px",
              borderBottomRightRadius: "20px",
              px: 1,
            }}
          >
            <Stack alignItems="center" py={5}>
              <img src={LOGO} alt="logo" width="100px" />
            </Stack>

            {renderLinks()}
          </Box>
        </Slide>
      </Modal>
    </>
  );
}
